import { render, staticRenderFns } from "./XiaochengxuQiandaoma.vue?vue&type=template&id=8ace1ff4&"
import script from "./XiaochengxuQiandaoma.vue?vue&type=script&lang=js&"
export * from "./XiaochengxuQiandaoma.vue?vue&type=script&lang=js&"
import style0 from "./XiaochengxuQiandaoma.vue?vue&type=style&index=0&id=8ace1ff4&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports